<section class="stepper">
  @if (header === true) {
    <header>
      <ul class="stepper__list list-unstyled mb-1" #list>
        @for (step of steps.toArray(); track step; let index = $index) {
          <li
            [ngClass]="{ checked: index < selectedIndex, 'dot--checked': index <= selectedIndex }"
            [ngStyle]="{
              width:
                index < steps.length - 1
                  ? 'calc(100% / ' + (steps.length - 1) + ' - ' + 12 / (steps.length - 1) + 'px)'
                  : '12px',
            }"
          >
            <span class="dot"></span>
            <span class="arrow"></span>
            <span class="arrow-animation"></span>
          </li>
        }
      </ul>
      <p class="text-center">
        {{ selected ? selected.label : 'Schritt' }} {{ selectedIndex + 1 }} / {{ steps.length }}
      </p>
    </header>
  }

  <div [ngTemplateOutlet]="selected ? selected.content : null"></div>

  @if (controls === true) {
    <footer class="d-flex justify-content-between">
      @if (selected.editable) {
        <button class="btn btn-outline-secondary" cdkStepperPrevious type="button">
          {{ 'button.go.back' | portalTranslate }}
        </button>
      }
      <button class="btn btn-primary" cdkStepperNext type="button">
        {{ 'button.go.forward' | portalTranslate }}
      </button>
    </footer>
  }
</section>
